module.exports = __webpack_public_path__ + "static/most-talkative-8a3ca3e8c093f4a9ba78f281424301d4.jpg";